import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useUserContext from 'Context/UserContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';

const styles = () => ({
  root: {},
});

const OnboardingDebugPanel = ({
  className,
  classes,
}) => {
  const { logout } = useUserContext();
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Button
        className={classes.headerBarLogoutButton}
        onClick={() => {
          logout();
        }}
        variant={'contained'}
        disableElevation
        color={'accentBlue'}
      >
        {'Logout'}
      </Button>
    </Box>
  );
};

OnboardingDebugPanel.defaultProps = {
  className: '',
};

OnboardingDebugPanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OnboardingDebugPanel);
